export type InlineHtmlTag = 'strong' | 'em' | 'u' | 's';

export type TextSelection = { start: number; end: number };

export function wrapTextSelectionWithHtml(
  currentValue: string,
  tagName: InlineHtmlTag,
  selection: TextSelection
): { text: string; selection: TextSelection; isHtml: true } {
  const openTag = `<${tagName}>`;
  const closeTag = `</${tagName}>`;
  const { start, end } = selection;

  if (end <= start) {
    const text = `${currentValue.slice(0, start)}${openTag}${closeTag}${currentValue.slice(end)}`;
    const cursor = start + openTag.length;
    return { text, selection: { start: cursor, end: cursor }, isHtml: true };
  }

  const selected = currentValue.slice(start, end);
  const text = `${currentValue.slice(0, start)}${openTag}${selected}${closeTag}${currentValue.slice(end)}`;
  const newStart = start + openTag.length;
  const newEnd = newStart + selected.length;
  return { text, selection: { start: newStart, end: newEnd }, isHtml: true };
}

export function clearInlineFormattingInSelection(
  currentValue: string,
  selection: TextSelection
): { text: string; selection: TextSelection; isHtml: true } | null {
  const { start, end } = selection;
  if (end <= start) return null;

  const selected = currentValue.slice(start, end);
  const strippedSelected = selected
    .replace(/<\/?(strong|em|u|s)\b[^>]*>/gi, '')
    .replace(/<\/?span\b[^>]*>/gi, '');
  const text = `${currentValue.slice(0, start)}${strippedSelected}${currentValue.slice(end)}`;
  const newEnd = start + strippedSelected.length;
  return { text, selection: { start, end: newEnd }, isHtml: true };
}

export function textContainsInlineHtml(text: string): boolean {
  return /<\/?(strong|em|u|s)\b[^>]*>/i.test(text);
}

export function resolveSelection(
  liveStart: number,
  liveEnd: number,
  cached: TextSelection | null
): TextSelection {
  if (liveEnd > liveStart) {
    return { start: liveStart, end: liveEnd };
  }
  if (cached) {
    return cached;
  }
  return { start: liveStart, end: liveEnd };
}
